import {CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthenticationService} from '../services/authentication/authentication.service';
import {UserRoles} from '../entities/user/user.entity';

@Injectable({
  providedIn: 'root'
})
export class PhotographerGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthenticationService) {}

  canActivate(): boolean {
    const user = this.authService.getCurrentUser();
    if (user && user.roles.includes(UserRoles.photographer)) {
      return true;
    }
    this.router.navigate(['/']); // Redirect if not a photographer
    return false;
  }
}
